import { render, staticRenderFns } from "./PhysicianView.vue?vue&type=template&id=95bc66a8&"
import script from "./PhysicianView.vue?vue&type=script&lang=js&"
export * from "./PhysicianView.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports